import type { IconProps } from './../../models/icon';

export function LikeIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill="#fff"
        d="M1.79325 9.96655H5.82401V20.6983H1.79325C1.56771 20.6983 1.35141 20.6087 1.19194 20.4492C1.03246 20.2896 0.942871 20.0735 0.942871 19.8478V10.8169C0.942871 10.5914 1.03246 10.3751 1.19194 10.2156C1.35141 10.0561 1.56771 9.96655 1.79325 9.96655Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M1.79325 9.96667H5.82401V20.6984H1.79325C1.56771 20.6984 1.35141 20.6088 1.19194 20.4494C1.03246 20.2898 0.942871 20.0736 0.942871 19.848V10.817C0.942871 10.5915 1.03246 10.3752 1.19194 10.2157C1.35141 10.0563 1.56771 9.96667 1.79325 9.96667Z"
      />
      <path
        fill={secondaryColor}
        d="M5.82373 9.96654L10.1436 3.06153C10.311 2.7886 10.5463 2.5637 10.8264 2.40871C11.1066 2.25373 11.4221 2.17394 11.7423 2.17713C11.9945 2.16803 12.2459 2.20958 12.4817 2.29929C12.7175 2.38902 12.933 2.52511 13.1153 2.69951C13.2977 2.87392 13.4432 3.08311 13.5433 3.31471C13.6434 3.54631 13.6961 3.79564 13.6982 4.04795V8.99713H21.1645C21.4403 9.00606 21.7112 9.07331 21.9593 9.19442C22.2073 9.31554 22.4269 9.48779 22.6035 9.69985C22.7802 9.91189 22.9102 10.1589 22.9846 10.4247C23.059 10.6906 23.0761 10.9691 23.0353 11.2421L21.6747 20.0179C21.6166 20.4869 21.3893 20.9186 21.0354 21.2318C20.6814 21.545 20.2254 21.7181 19.7528 21.7186H8.59594C8.06483 21.7207 7.5406 21.5984 7.06527 21.3615L5.84074 20.7492"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M5.82373 9.96611L10.1436 3.06109C10.311 2.78817 10.5463 2.56326 10.8264 2.40827C11.1066 2.25328 11.4221 2.17352 11.7423 2.17671C11.9945 2.1676 12.2459 2.20914 12.4817 2.29887C12.7175 2.38859 12.933 2.52467 13.1153 2.69908C13.2977 2.87349 13.4432 3.08267 13.5433 3.31429C13.6434 3.54589 13.6961 3.79521 13.6982 4.04752V8.99668H21.1645C21.4403 9.00563 21.7112 9.07287 21.9593 9.194C22.2073 9.31511 22.4269 9.48734 22.6035 9.6994C22.7802 9.91146 22.9102 10.1585 22.9846 10.4243C23.059 10.6901 23.0761 10.9687 23.0353 11.2417L21.6747 20.0175C21.6166 20.4865 21.3893 20.9182 21.0354 21.2314C20.6814 21.5446 20.2254 21.7177 19.7528 21.7183H8.59594C8.06483 21.7203 7.5406 21.5981 7.06527 21.361L5.84074 20.7488"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M5.82373 9.96655V20.6983"
      />
    </svg>
  );
}
